/** Scheduling type enum. */
export var SchedulingType;
(function (SchedulingType) {
    /** Unknown scheduling type. */
    SchedulingType["UNKNOWN_SCHEDULING"] = "UNKNOWN_SCHEDULING";
    /** Orders can be scheduled for the future and to be handled immediately. */
    SchedulingType["ASAP"] = "ASAP";
    /** Orders can be scheduled only for the future. */
    SchedulingType["PREORDER"] = "PREORDER";
})(SchedulingType || (SchedulingType = {}));
/** Preparation time type enum. */
export var PreparationTimeType;
(function (PreparationTimeType) {
    /** Unknown preparation time type. */
    PreparationTimeType["UNKNOWN_PREPARATION_TIME"] = "UNKNOWN_PREPARATION_TIME";
    /** Preparation time that is bounded by a maximum time. */
    PreparationTimeType["MAX"] = "MAX";
    /** Preparation time that is bounded by a range of times. */
    PreparationTimeType["RANGE"] = "RANGE";
})(PreparationTimeType || (PreparationTimeType = {}));
/** Time unit enum. */
export var TimeUnit;
(function (TimeUnit) {
    /** Unknown time unit. */
    TimeUnit["UNKNOWN_TIME_UNIT"] = "UNKNOWN_TIME_UNIT";
    /** Minutes time unit. */
    TimeUnit["MINUTES"] = "MINUTES";
    /** Hours time unit. */
    TimeUnit["HOURS"] = "HOURS";
    /** Days time unit. */
    TimeUnit["DAYS"] = "DAYS";
})(TimeUnit || (TimeUnit = {}));
/** Asap preorder type enum. */
export var AsapPreorderType;
(function (AsapPreorderType) {
    /** Unknown ASAP preorder type. */
    AsapPreorderType["UNKNOWN_ASAP_PREORDER"] = "UNKNOWN_ASAP_PREORDER";
    /** Doesn't allow preorder. */
    AsapPreorderType["NO_PREORDER"] = "NO_PREORDER";
    /** Allows preorder for a maximum specified number of business days in advance. */
    AsapPreorderType["BUSINESS_DAYS_PREORDER"] = "BUSINESS_DAYS_PREORDER";
})(AsapPreorderType || (AsapPreorderType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    /** Monday. */
    DayOfWeek["MON"] = "MON";
    /** Tuesday. */
    DayOfWeek["TUE"] = "TUE";
    /** Wednesday. */
    DayOfWeek["WED"] = "WED";
    /** Thursday. */
    DayOfWeek["THU"] = "THU";
    /** Friday. */
    DayOfWeek["FRI"] = "FRI";
    /** Saturday. */
    DayOfWeek["SAT"] = "SAT";
    /** Sunday. */
    DayOfWeek["SUN"] = "SUN";
})(DayOfWeek || (DayOfWeek = {}));
/** Preorder method type enum. */
export var MethodType;
(function (MethodType) {
    /** Unknown preorder method type. */
    MethodType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Preorder time has a minimum and a maximum. */
    MethodType["TIME_BOUNDED"] = "TIME_BOUNDED";
    /** Preorders have a weekly schedule with a weekly cutoff time. */
    MethodType["WEEKLY_SCHEDULE"] = "WEEKLY_SCHEDULE";
})(MethodType || (MethodType = {}));
/** The fulfillment times type enum. */
export var FulfillmentTimesType;
(function (FulfillmentTimesType) {
    /** Unknown fulfillment times type. */
    FulfillmentTimesType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Display fulfillment times as time windows. */
    FulfillmentTimesType["TIME_WINDOWS"] = "TIME_WINDOWS";
})(FulfillmentTimesType || (FulfillmentTimesType = {}));
/** Online ordering status enum. */
export var OnlineOrderingStatusType;
(function (OnlineOrderingStatusType) {
    /** Online ordering status is not defined. */
    OnlineOrderingStatusType["UNDEFINED_ONLINE_ORDERING_STATUS"] = "UNDEFINED_ONLINE_ORDERING_STATUS";
    /** Operation currently accepts online orders. */
    OnlineOrderingStatusType["ENABLED"] = "ENABLED";
    /** Operation currently does not accept online orders. */
    OnlineOrderingStatusType["DISABLED"] = "DISABLED";
    /** Operation currently does not accept online orders, but will accept online orders from a specified time and date. When applied, `pausedUntilOptions` is a required field. */
    OnlineOrderingStatusType["PAUSED_UNTIL"] = "PAUSED_UNTIL";
})(OnlineOrderingStatusType || (OnlineOrderingStatusType = {}));
/** Fulfillment type enum. */
export var FulfillmentType;
(function (FulfillmentType) {
    /** Undefined fulfillment type. */
    FulfillmentType["UNDEFINED_FULFILLMENT_TYPE"] = "UNDEFINED_FULFILLMENT_TYPE";
    /** Pickup fulfillment. */
    FulfillmentType["PICKUP"] = "PICKUP";
    /** Delivery fulfillment. */
    FulfillmentType["DELIVERY"] = "DELIVERY";
})(FulfillmentType || (FulfillmentType = {}));
/** Preparation time type enum. */
export var PreparationTimePreparationTimeType;
(function (PreparationTimePreparationTimeType) {
    PreparationTimePreparationTimeType["UNKNOWN_PREPARATION_TIME"] = "UNKNOWN_PREPARATION_TIME";
    PreparationTimePreparationTimeType["MAX_TIME"] = "MAX_TIME";
    PreparationTimePreparationTimeType["TIME_RANGE"] = "TIME_RANGE";
})(PreparationTimePreparationTimeType || (PreparationTimePreparationTimeType = {}));
export var AsapFutureHandlingType;
(function (AsapFutureHandlingType) {
    /** Unknown asap future handling type. */
    AsapFutureHandlingType["UNKNOWN_ASAP_FUTURE_HANDLING"] = "UNKNOWN_ASAP_FUTURE_HANDLING";
    /** No future handling. */
    AsapFutureHandlingType["NO_FUTURE_HANDLING"] = "NO_FUTURE_HANDLING";
    /** Allows future orders for up to a specified number of business days ahead. */
    AsapFutureHandlingType["BUSINESS_DAYS_AHEAD_HANDLING"] = "BUSINESS_DAYS_AHEAD_HANDLING";
})(AsapFutureHandlingType || (AsapFutureHandlingType = {}));
/** Preorder pacing window type enum */
export var PreorderPacingWindowType;
(function (PreorderPacingWindowType) {
    /** Unknown preorder pacing window type */
    PreorderPacingWindowType["UNKNOWN_PREORDER_PACING_WINDOW"] = "UNKNOWN_PREORDER_PACING_WINDOW";
    /** Daily pacing window */
    PreorderPacingWindowType["DAILY"] = "DAILY";
})(PreorderPacingWindowType || (PreorderPacingWindowType = {}));
/** Defines when pacing should be active */
export var PacingAvailabilityType;
(function (PacingAvailabilityType) {
    /** Unknown pacing schedule type */
    PacingAvailabilityType["UNKNOWN_SCHEDULE"] = "UNKNOWN_SCHEDULE";
    /** Pacing is active 24/7 */
    PacingAvailabilityType["ALWAYS_ACTIVE"] = "ALWAYS_ACTIVE";
    /** Pacing follows custom availability pattern */
    PacingAvailabilityType["SCHEDULE"] = "SCHEDULE";
})(PacingAvailabilityType || (PacingAvailabilityType = {}));
/** ASAP pacing duration type enum */
export var AsapPacingDurationType;
(function (AsapPacingDurationType) {
    /** Unknown ASAP pacing duration type */
    AsapPacingDurationType["UNKNOWN_ASAP_PACING_DURATION"] = "UNKNOWN_ASAP_PACING_DURATION";
    /** Fixed 15-minute window */
    AsapPacingDurationType["FIXED_15_MINUTE"] = "FIXED_15_MINUTE";
})(AsapPacingDurationType || (AsapPacingDurationType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
/** Fulfillment time type enum. */
export var FulfillmentTimeType;
(function (FulfillmentTimeType) {
    /** Undefined fulfillment time type. */
    FulfillmentTimeType["UNDEFINED_FULFILLMENT_TIME"] = "UNDEFINED_FULFILLMENT_TIME";
    /** Fulfillment time has a maximum. */
    FulfillmentTimeType["MAX_TIME"] = "MAX_TIME";
    /** Fulfillment time has a minimum and a maximum. */
    FulfillmentTimeType["DURATION_RANGE"] = "DURATION_RANGE";
})(FulfillmentTimeType || (FulfillmentTimeType = {}));
/** Fulfillment times display type enum. */
export var FulfillmentTimesDisplayType;
(function (FulfillmentTimesDisplayType) {
    /** Undefined fulfillment times display type. */
    FulfillmentTimesDisplayType["UNDEFINED_FULFILLMENT_TIMES_DISPLAY"] = "UNDEFINED_FULFILLMENT_TIMES_DISPLAY";
    /** Fulfillment times are displayed as a list of time windows. */
    FulfillmentTimesDisplayType["TIME_WINDOWS"] = "TIME_WINDOWS";
})(FulfillmentTimesDisplayType || (FulfillmentTimesDisplayType = {}));
export var OrderSchedulingType;
(function (OrderSchedulingType) {
    /** Immediate (ASAP) order time slot. */
    OrderSchedulingType["ASAP"] = "ASAP";
    /** Scheduled order time slot (i.e., for future delivery/pickup). */
    OrderSchedulingType["PREORDER"] = "PREORDER";
})(OrderSchedulingType || (OrderSchedulingType = {}));
/** Type of violation found in the address */
export var ViolationType;
(function (ViolationType) {
    ViolationType["UNKNOWN"] = "UNKNOWN";
    ViolationType["NO_ADDRESS"] = "NO_ADDRESS";
    ViolationType["MISSING_FORMATTED_ADDRESS"] = "MISSING_FORMATTED_ADDRESS";
    ViolationType["INVALID_GEOCODE"] = "INVALID_GEOCODE";
    ViolationType["MISSING_COUNTRY"] = "MISSING_COUNTRY";
    ViolationType["MISSING_SUBDIVISION"] = "MISSING_SUBDIVISION";
})(ViolationType || (ViolationType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var V4DayOfWeek;
(function (V4DayOfWeek) {
    V4DayOfWeek["MONDAY"] = "MONDAY";
    V4DayOfWeek["TUESDAY"] = "TUESDAY";
    V4DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    V4DayOfWeek["THURSDAY"] = "THURSDAY";
    V4DayOfWeek["FRIDAY"] = "FRIDAY";
    V4DayOfWeek["SATURDAY"] = "SATURDAY";
    V4DayOfWeek["SUNDAY"] = "SUNDAY";
})(V4DayOfWeek || (V4DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
    Namespace["NOWNIA"] = "NOWNIA";
    /**
     * UGC Templates are templates that are created by users for personal use and to sale to other users.
     * The Partners company owns this namespace.
     */
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    /** Codux Headless Sites */
    Namespace["CODUX"] = "CODUX";
    /** Bobb - AI Design Creator. */
    Namespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
    /**
     * Shared Blog Site is a unique single site across Enterprise account,
     * This site will hold all Blog posts related to the Marketing product.
     */
    Namespace["SHARED_BLOG_ENTERPRISE"] = "SHARED_BLOG_ENTERPRISE";
    /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_FORMS"] = "STANDALONE_FORMS";
    /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_EVENTS"] = "STANDALONE_EVENTS";
    /** MIMIR - Siteless account for MIMIR Ai Job runner. */
    Namespace["MIMIR"] = "MIMIR";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
    DeleteStatus["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(DeleteStatus || (DeleteStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map